import { AbstractModel, DateUtil, EqualityInterface, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class CustomerServiceNoteDetail implements EqualityInterface<CustomerServiceNoteDetail> {
  @autoserialize
  id: number;

  @autoserialize
  objectId: number;

  @autoserialize
  text: string;

  @autoserialize
  active: boolean;

  @autoserialize
  objectName: string;

  @autoserialize
  createdBy: string;

  @autoserialize
  createdAt: Date;

  /**** Serialization ****/

  static OnSerialized(instance: CustomerServiceNoteDetail, json: any): void {
    if (!isNullOrUndefined(instance.createdAt)) {
      json.createdAt = DateUtil.serializeDate(instance.createdAt);
    }
  }

  static OnDeserialized(instance: CustomerServiceNoteDetail, json: any): void {
    if (!isNullOrUndefined(json['createdAt'])) {
      instance.createdAt = DateUtil.deserializeDate(json['createdAt']);
    }
  }

  /**** Equality ****/

  equals(comparisonObject: CustomerServiceNoteDetail): boolean {
    return isNullOrUndefined(comparisonObject) ? false : this.id === comparisonObject.id;
  }
}
